import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface Requisite {
  renter_id: number;
  display_name: string;
  inn: number;
  kpp: number;
  ogrn: number;
  bank_account: string;
  bank_name: string;
  bik: string;
  correspondent_account: string;
  address: string;
  phone: string;
  email: string;
  created_at: string;
  currency: number;
  id: number;
}

export interface RequisiteCreate {
  renter_id: number;
  display_name: string;
  inn: number;
  kpp: number;
  ogrn: number;
  bank_account: string;
  bank_name: string;
  bik: string;
  correspondent_account: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
}

export interface RequisiteUpdate {
  renter_id: number;
  display_name: string;
  inn: number;
  kpp: number;
  ogrn: number;
  bank_account: string;
  bank_name: string;
  bik: string;
  correspondent_account: string;
  address: string;
  phone: string;
  email: string;
  currency: number;
}

export function RequisitesAPI(baseUrl: string) {
  return {
    list: async () => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/requisites?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Requisite[]>;
    },
    listByRenter: async (renterId: number) => {
      return (await crud.get(
        `${baseUrl}/requisites?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Requisite[]>;
    },
    get: async (id: number) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.get(
        `${baseUrl}/requisites/${id}?renter_id=${renterId}`,
        undefined,
        true,
      )) as ApiResponse<Requisite>;
    },
    create: async (params: RequisiteCreate) => {
      const renterId =
        rootStore.getState().location.location.id || params.renter_id;
      return (await crud.post(
        `${baseUrl}/requisites?renter_id=${renterId}`,
        params,
        true,
      )) as ApiResponse<Requisite>;
    },
    update: async (id: number, params: RequisiteUpdate) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.put(
        `${baseUrl}/requisites/${id}?renter_id=${renterId}`,
        params,
        true,
      )) as ApiResponse<Requisite>;
    },
    delete: async (id: number) => {
      const renterId = rootStore.getState().location.location.id;
      return (await crud.delete(
        `${baseUrl}/requisites/${id}?renter_id=${renterId}`,
        true,
      )) as ApiResponse<object>;
    },
  };
}
